module.exports = __webpack_public_path__ + "static/img/wwwwww.06084528.jpg";